import { useState } from "react";
import { DashboardIcon } from "../icons/DashboardIcon";
import { ProjectIcon } from "../icons/ProjectIcon";
import { Logo } from "../icons/Logo";
import {
  StyledBack,
  StyledBadge,
  StyledLogo,
  StyledMain,
  StyledMenu,
  StyledMenuIcon,
  StyledMenuItem,
  StyledMenuTitle,
  StyledTitle,
} from "./styled";
import { RequestsForAmend } from "../icons/RequestsForAmend";
import { SiderBackIcon } from "../icons/SiderBackIcon";
import { useLocation, useNavigate } from "react-router-dom";

export const MenuList = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const [sidebarItems, setSidebarItems] = useState([
    {
      key: "1.1",
      title: "Дашборд",
      icon: <DashboardIcon />,
      dot: false,
      link: "dashboard",
    },
    {
      key: "1.2",
      title: "Проекты",
      icon: <ProjectIcon />,
      dot: true,
      link: "projects",
    },
    {
      key: "1.3",
      title: "Заявки на ИЗМ",
      icon: <RequestsForAmend />,
      dot: false,
      link: "#",
    },
  ]);

  return (
    <StyledMenu>
      <StyledMain>
        <StyledLogo>
          <Logo />
        </StyledLogo>
        {sidebarItems.map((item) => (
          <StyledBadge key={item.key} dot={item.dot} color="#F04B69">
            <StyledMenuItem
              className={
                location.pathname.includes(item.link)
                  ? "active"
                  : item.link !== "#"
                  ? "item"
                  : "none"
              }
              onClick={() => {
                navigate(item.link);
              }}
            >
              <StyledMenuTitle>
                <StyledMenuIcon
                  className={
                    location.pathname.includes(item.link) ? "active" : "item"
                  }
                >
                  {item.icon}
                </StyledMenuIcon>
                <StyledTitle>{item.title}</StyledTitle>
              </StyledMenuTitle>
            </StyledMenuItem>
          </StyledBadge>
        ))}
      </StyledMain>

      <StyledBack>
        <div>
          <SiderBackIcon />
        </div>
      </StyledBack>
    </StyledMenu>
  );
};
